/*
 results FORM LOGIC DOCTOR DISCUSSION GUIDE
 */

results = {

	init: function(){
		results.cE();
	},
	cE: function cacheElements() {

		results.fullURL = window.location.href;
		results.url = window.location.search.substring(1);

		results.printButton = $('[data-action="print-results"]');

		results.submitTextButton = $('[data-action="submit-text-results"]');

		results.textForm = $('[data-form="text-results-form"]');
		results.phoneNumber = $('input[type="tel"]');
		results.hiddenField = $('input[name="results_url"]');
		results.hiddenResults = $('input[name="Assessment__c"]');
		results.submittingMsg = $('.submitting-msg');
		results.successMsg = $('.success-msg');
		results.phoneError = $('.phone-error');
		results.errors = null;

		results.actionButtonWrapper = $('.action-buttons');
		results.el();
	},
	el: function eventListeners() {
		$(window).on('load', function(){
			// ADD URL OF RESULTS PAGE TO HIDDEN FIELD IN FORM
			results.addURLtoHiddenField();
		});

		// EVENT LISTENER FOR PRINT RESULTS BUTTON
		$(results.printButton).on('click', function(e){
			e.preventDefault();
			window.print();
		});


		// EVENT LISTENER FOR SUBMIT BUTTON ON PHONE NUMBER FORM
		$(results.submitTextButton).on('click', function(e){
			e.preventDefault();
			if (!$(results.submitTextButton).hasClass('disabled')){
				results.validateTextForm();
			}
		});

		//	EVENT LISTENER FOR HITTING ENTER KEY ON PHONE NUMBER FORM
		$(results.phoneNumber).on('keydown', function(e){
            results.onlyAllowNumbers( e );
            results.checkAndAddSlashes( e );
		});
	},
    // ONLY ALLOW NUMBERS IN PHONE NUMBER
    onlyAllowNumbers: function (evt) {
        // Allow: backspace, delete, tab, escape, enter
        if ( $.inArray( evt.key ,["0" ,"1" ,"2" ,"3" ,"4" ,"5" ,"6" ,"7" ,"8" ,"9" ,"Backspace" ,"Delete" ,"Escape" ,"Enter" ,"ArrowRight" ,"ArrowLeft" ,"Tab"] ) === -1 ) {
            evt.preventDefault();
        }
    } ,
    // ADD SLASHES AS USER TYPES
    checkAndAddSlashes: function (evt) {

        const keyCodes = [8 ,37 ,38 ,39 ,40] ,
            str = evt.target.value;

        if ( $.inArray( evt.keyCode ,keyCodes ) === -1 ) {
            switch (str.length) {
                case 3:
                    $( evt.target ).val( str + "-" );
                    break;
                case 7:
                    $( evt.target ).val( str + "-" );
                    break;
                default:
                    break;
            }

        }
    } ,
	validateTextForm: function validateTextForm() {
		results.errors = 0;
		if ($('.show-error')){
			$(results.textForm).removeClass('show-error');
			results.phoneError.removeClass('error');
		}
		$('.errOpt.errPhone').hide();
		var regEx 		= /^([2-9]{1})([0-9]{2})[\-\.\ ]?([0-9]{3})[-. ]?([0-9]{4})$/,
				phoneVal	= $(results.phoneNumber).val(),
        clean 		= phoneVal.replace(/\D/g,'');
        validatePhone.hideCustomPhoneError();
    // If there have already been 2 errors, let this pass (having already verified it's a good number via regex)
		if(validatePhone.errorCount >= 2 && (phoneVal.match(regEx)&& clean.length === 10)) {
			$(results.textForm).addClass('hide-form');
			$(results.submittingMsg).addClass('show-msg');
			results.submitTextForm();
			return;
		}
		var phonetype = 'carrier';
		var json = {type: phonetype, phone: clean};

		$.ajax({
			type: "POST",
			url: '/api/validatephone/',
			data: json,
			dataType: 'json',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
		}).done(function(d){
			var t = d.type;
			if(t !== "mobile" && validatePhone.errorCount < 2) {
				// if phone type (t) equals null then show regular phone error (will come back as null if phone number is blank or less than 10 digits)
				if(t === null){
					results.phoneError.addClass('error');
				}
				validatePhone.phoneValid = false;
				validatePhone.showCustomPhoneError(t);
				validatePhone.errorCount++;
				results.textForm.addClass('show-error');

				return false;
			} else if(phoneVal.match(regEx) && clean.length === 10) {
				validatePhone.phoneValid = true;
				$(results.textForm).addClass('hide-form');
				$(results.submittingMsg).addClass('show-msg');
				results.submitTextForm();
				return true;
			} else {
				results.phoneError.addClass('error');
				results.textForm.addClass('show-error');
			}
		});
	},
	submitTextForm: function submitTextForm(){
		var formData = $(results.textForm).serialize();
        $.ajax({
            type: "POST",
            url: '/api/ddgtext/',
            data: formData,
            dataType: 'json',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        }).done(function(d){
            results.formSuccess();
        });
	},
	formSuccess: function formSuccess(){
		$(results.submittingMsg).removeClass('show-msg');
		$(results.successMsg).addClass('show-msg');
		$(results.submitTextButton).addClass('disabled');
		results.addToDataLayer();
	},
	addToDataLayer: function addToDataLayer(){
		window.dataLayer.push({
			'event': 'textMyResults',
			'eventCategory': 'CTA',
			'eventAction': 'Click-In Site',
			'eventLabel': 'Text Me My Results'
		});
	},
	addURLtoHiddenField: function addURLtoHiddenField(){
		$(results.hiddenField).val(results.fullURL);
		var oldResults = results.url;
		var newResults = oldResults.replace('form_name=assessment&', '');
		$(results.hiddenResults).val(newResults);
	},
};
